import { render, staticRenderFns } from "./InvestmentsResourceList.vue?vue&type=template&id=7be750c8&scoped=true"
import script from "./InvestmentsResourceList.vue?vue&type=script&lang=js"
export * from "./InvestmentsResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be750c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7be750c8')) {
      api.createRecord('7be750c8', component.options)
    } else {
      api.reload('7be750c8', component.options)
    }
    module.hot.accept("./InvestmentsResourceList.vue?vue&type=template&id=7be750c8&scoped=true", function () {
      api.rerender('7be750c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resourceManager/InvestmentsResourceList.vue"
export default component.exports